import { useEffect, useState } from 'react';

import { PortalPaymentFragment, PortalWorkoutPlanFragment } from '@willow/graphql-iso/src/graphql/portal/generated';

import { ActiveWorkoutPlanAlert } from '../../payment-form/alerts/ActiveWorkoutPlanAlert';

/** The logic around paymentDueStatus was getting messy when trying to incorporate an active workout plan,
 * so at least for now, just use a separate component and don't worry about displaying processing or previous payments (those will still display in the transactions tab)
 */
export const PaidCurrentWithWorkoutPlan = ({
  activeWorkoutPlan,
  totalAmountDue,
  payments,
  onAdditionalPayment,
}: {
  activeWorkoutPlan: PortalWorkoutPlanFragment;
  totalAmountDue: number;
  payments: PortalPaymentFragment[];
  onAdditionalPayment: () => void;
}) => {
  const [displayMorePayment, setDisplayMorePayment] = useState(true);

  useEffect(() => {
    // re-display the section everytime a new payment is made
    setDisplayMorePayment(true);
  }, [payments]);

  return (
    <>
      {displayMorePayment && (
        <>
          <ActiveWorkoutPlanAlert activeWorkoutPlan={activeWorkoutPlan} totalAmountDue={totalAmountDue} />

          <section className="payment-details payment-details__container payment-details__more">
            <h2>No payment due</h2>
            <h3>Your next statement will be available soon with payment details</h3>

            <div className="payment-details__addition">
              <button
                className="payment-details__addition__btn"
                data-ghost="portal-loan--make-a-payment-button"
                onClick={() => {
                  setDisplayMorePayment(false);
                  onAdditionalPayment();
                }}
              >
                Make Another Payment
              </button>
            </div>
          </section>
        </>
      )}
    </>
  );
};
